import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value !== _vm.emptyValue)?[_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({staticClass:"alert-icon mr-1",attrs:{"size":"15","color":"error"}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert ")])]}}],null,false,3861773059)},[_c('span',[_vm._v(_vm._s(_vm.value))])])]:_c('span',[_c(VIcon,_vm._g(_vm._b({staticClass:"alert-icon mr-1",attrs:{"size":"15","color":"success"}},'v-icon',_vm.attrs,false),_vm.on),[_vm._v(" mdi-check-circle ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }